import React from 'react';
import { PreviewContent } from '../../../../styles/TradeDocStyles';
import { REACT_APP_BASE_URL } from '../../../../config';
import DocumentViewer from '../../../DocumentViewer/DocumentViewer';
import { Stack } from '@mui/material';
import moment from 'moment';
import { formatNumber } from '../../../../utils/helper';
import { TransformedItems } from '../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';

const BillOfLadenMobilePreview = ({
    data,
    docTitle,
    quoteFields,
    totalAmount,
    signatureUrlBase64
}: {
    data: any;
    docTitle: string;
    quoteFields: TransformedItems[];
    totalAmount?: number;
    signatureUrlBase64: string;
}) => {
    return (
        <PreviewContent style={{ padding: '25px 0' }}>
            <div className='flex items-center justify-start pb-4 mb-4 border-b'>
                {data?.logoUrl ? (
                    <div className='h-[4rem] w-[100%] '>
                        <DocumentViewer
                            fileUrl={`${REACT_APP_BASE_URL}/${data?.logoUrl.split(
                                '/v1/'
                            )[1]}`}
                        />
                    </div>
                ) : (
                    <>
                        <div>
                            <img
                                src='/img/vectors/powered.svg'
                                alt=''
                                className=' h-[50px]'
                            />
                        </div>
                    </>
                )}
            </div>{' '}
            <Stack
                direction='column'
                alignItems='start'
                className='top-preview-content space-y-4'
                width='full'
                justifyContent={'space-between'}
            >
                <div className='view-one' style={{ maxWidth: '100%' }}>
                    <p className='font-semibold text-appcolorprimary'>
                        Consigner/Shipper{' '}
                    </p>
                    <p className='font-medium'>{data?.shipperName || '--'}</p>
                    <p>{data?.shipperAddress}</p>
                    <p>{data?.shipperCountry}</p>

                    <div className='mt-[15px] w-full'>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Bank Name</p>
                            <p className='value'>{data?.shipperBank || '--'}</p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Account No.</p>
                            <p className='value'>
                                {data?.shipperAccountNumber || '--'}
                            </p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Swift Code</p>
                            <p className='value'>
                                {data?.shipperSwiftCode || '--'}
                            </p>
                        </Stack>
                    </div>
                </div>

                <div className='view-two' style={{ maxWidth: '100%' }}>
                    <p className='font-semibold text-appcolorprimary'>
                        Consignee
                    </p>
                    <p className='font-medium'>{data?.consigneeName || '--'}</p>
                    <p>{data?.consigneeAddress}</p>
                    <p>{data?.consigneeCountry}</p>

                    <div className='mt-[15px] w-full'>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Bank Name</p>
                            <p className='value'>
                                {data?.consigneeBank || '--'}
                            </p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Account No.</p>
                            <p className='value'>
                                {data?.consigneeAccountNumber || '--'}
                            </p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Swift Code</p>
                            <p className='value'>
                                {data?.consigneeSwiftCode || '--'}
                            </p>
                        </Stack>
                    </div>
                </div>

                <div className='view-three' style={{ maxWidth: '100%' }}>
                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                        style={{ marginBottom: 0 }}
                    >
                        <p className='title'>MTD No.</p>
                        <p className='value'>{data?.mtdNumber || '--'}</p>
                    </Stack>

                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                    >
                        <p className='title'>Date</p>
                        <p className='value'>
                            {moment(data?.issuedDate).format('ll') || '--'}
                        </p>
                    </Stack>

                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                    >
                        <p className='title'>Place of Receipt</p>
                        <p className='value'>{data?.placeOfReceipt || '--'}</p>
                    </Stack>

                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                    >
                        <p className='title'>Shipment Ref No.</p>
                        <p className='value'>
                            {data?.shipmentReferenceNumber || '--'}
                        </p>
                    </Stack>
                </div>
            </Stack>
            <Stack
                direction='column'
                alignItems='start'
                className='mid-preview-content border-b pb-4'
                width='full'
                justifyContent={'space-between'}
                style={{ borderTop: '1px solid #e5e7eb', marginBottom: 0 }}
            >
                <div className='view-one' style={{ maxWidth: '100%' }}>
                    <div className='flex justify-between'>
                        <p className='title'>Notify Party</p>
                        <p className='value'>{data?.notifyPartyName || '--'}</p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>Port of Loading</p>
                        <p className='value'>
                            {data?.portOfLoadingValue?.name || '--'}
                        </p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>Vessel & Voyage</p>
                        <p className='value'>{data?.vesselAndVoyage || '--'}</p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>Port of Departure</p>
                        <p className='value'>
                            {data?.portOfDischargeValue?.name}
                        </p>
                    </div>{' '}
                </div>

                <div className='view-one' style={{ maxWidth: '100%' }}>
                    <div className='flex justify-between'>
                        <p className='title'>Place of Delivery</p>
                        <p className='value'>{data?.placeOfDelivery || '--'}</p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>End of Delivery Date</p>
                        <p className='value'>
                            {' '}
                            {moment(data?.endDateOfDelivery).format('ll')}
                        </p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>Transport</p>
                        <p className='value'>{data?.transport || '--'}</p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>Route/ Place of Transhipment</p>
                        <p className='value'>
                            {data?.placeOfTranshipment || '--'}
                        </p>
                    </div>{' '}
                </div>
            </Stack>
            {quoteFields?.map((item: any) => (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='mid-preview-content mt-0 border-b border-dashed bg-aliceBlue p-2'
                    width='full'
                    justifyContent={'space-between'}
                    style={{
                        borderStyle: 'dashed',
                        marginBottom: 0,
                        marginTop: 0
                    }}
                >
                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Product Code</p>
                            <p className='value'>{item.productCode ?? '--'}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Description of Goods</p>
                            <p className='value'>{item.desc ?? '--'}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Package Kind </p>
                            <p className='value'>
                                {item.kindOfPackage ?? '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Package Quantity </p>
                            <p className='value'>
                                {formatNumber(item.qtyOfPackage ?? 0)}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Chargeable</p>
                            <p className='value'>{item.chargeable ?? '--'}</p>
                        </div>
                    </div>
                </Stack>
            ))}
            <Stack direction='row' justifyContent='flex-end'>
                <div className='preview-total w-full flex justify-between border-t border-b border-appcolorprimary py-4'>
                    Total Weight :{' '}
                    <span className=''>
                        {formatNumber(data?.totalGrossWeight || 0)} Kg
                    </span>
                </div>
            </Stack>
            <Stack
                direction='column'
                alignItems='start'
                className='bottom-preview-content'
                width='full'
                justifyContent={'space-between'}
                style={{
                    position: 'static',
                    marginTop: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }}
            >
                <div
                    className='view-one space-y-2'
                    style={{ maxWidth: '100%' }}
                >
                    <div>
                        <p className='titl'>Delivery Agent</p>
                        <p>{data?.deliveryAgent || '--'}</p>
                    </div>
                    <div>
                        <p className='titl'>Number of Originals</p>
                        <p>{data?.noOfOriginals || '--'}</p>
                    </div>
                </div>

                <div
                    className='view-two space-y-2'
                    style={{ maxWidth: '100%' }}
                >
                    <div>
                        <p className='titl'>Freight Amount</p>
                        <p className=''>{data?.freightAmount || '--'}</p>
                    </div>
                    <div>
                        <p className='titl'>Freight Payable At</p>
                        <p>{data?.freightPayableAt || '--'}</p>
                    </div>
                </div>

                <div
                    className='view-three  space-y-2'
                    style={{ maxWidth: '100%' }}
                >
                    <div>
                        {' '}
                        <p className='titl'>Place of Issue</p>
                        <p>{data?.placeOfIssue || '--'}</p>
                    </div>
                    <div>
                        <p className='titl'>Signature</p>
                        <img src={`${signatureUrlBase64}`} alt='' />
                    </div>
                </div>
            </Stack>
        </PreviewContent>
    );
};

export default BillOfLadenMobilePreview;
